import FrontEndApi from '../../../Common/Globals/Scripts/FrontEndApi';

async function resetPassword(userName, code, password) {
    return await FrontEndApi.resetPassword(userName, code, password);
}

export default { resetPassword }
